import { http } from '@/utils/axios'

/**
 * @msg: 获取课程信息
 */
export function getCourseScoreInfo(data) {
    return http({
        url: http.baseUrl('myLecture/getCourseScoreInfo'),
        method: 'post',
        params: http.params(data),
        data
    })
}

/**
 * @msg: 获取点播课程学员列表
 */
export function getCourseScore(data) {
    return http({
        url: http.baseUrl('myLecture/getCourseScore'),
        method: 'post',
        params: http.params(data),
        data
    })
}

/**
 * @msg: 督学
 */
export function superintendent(data) {
    return http({
        url: http.baseUrl('myLecture/superintendent'),
        method: 'post',
        params: http.params(data),
        data
    })
}

/**
 * @msg: 获取学习记录
 */
export function getLearnRecord(data) {
    return http({
        url: http.baseUrl('myLecture/getLearnRecord'),
        method: 'post',
        params: http.params(data),
        data
    })
}

/**
 * @msg: 获取直播课程学员列表
 */
export function getLiveCourse(data) {
    return http({
        url: http.baseUrl('myLecture/getLiveCourse'),
        method: 'post',
        params: http.params(data),
        data
    })
}

/**
 * @msg: 获取线下课程学员列表
 */
export function getOfflineCourses(data) {
    return http({
        url: http.baseUrl('myLecture/getOfflineCourses'),
        method: 'post',
        params: http.params(data),
        data
    })
}

/**
 * @msg: 获取考勤结果
 */
export function getSignByUid(data) {
    return http({
        url: http.baseUrl('zkolSignRecord/getSignByUid'),
        method: 'post',
        params: http.params(data),
        data
    })
}